import { FileType } from "src/components/10-atoms/file-picker/types";
function getFileExtension(file) {
    return file.split('.').pop()?.toLowerCase() || '_UNKNOWN_';
}
function getFileTypeFromExtension(extension) {
    if (['jpg', 'jpeg', 'png', 'gif', 'bmp', 'tiff', 'ico', 'webp'].includes(extension)) {
        return FileType.IMAGES;
    }
    else if (extension === 'pdf') {
        return FileType.PDF;
    }
    return '_UNKNOWN_';
}
function getFileTypeFromMimeType(mimeType) {
    if (mimeType.startsWith('image/')) {
        return FileType.IMAGES;
    }
    else if (mimeType.startsWith('application/pdf')) {
        return FileType.PDF;
    }
    return '_UNKNOWN_';
}
export function getFileType(file) {
    if (typeof file === 'string') {
        return getFileTypeFromExtension(getFileExtension(file));
    }
    const fileType = file.type;
    return getFileTypeFromMimeType(fileType);
}
